// extracted by mini-css-extract-plugin
export var aside1 = "ArticleBody-module--aside1--cd636";
export var aside2 = "ArticleBody-module--aside2--064d4";
export var author = "ArticleBody-module--author--fa65a";
export var authorBody = "ArticleBody-module--authorBody--f24f1";
export var authorDesc = "ArticleBody-module--authorDesc--ae5fc";
export var authorImg = "ArticleBody-module--authorImg--74754";
export var authorName = "ArticleBody-module--authorName--e3526";
export var body = "ArticleBody-module--body--0384e";
export var container = "ArticleBody-module--container--eb76b";
export var nav = "ArticleBody-module--nav--00e36";
export var sticky = "ArticleBody-module--sticky--f89f7";
export var tag = "ArticleBody-module--tag--a4485";
export var tags = "ArticleBody-module--tags--c7164";